module.exports = __webpack_public_path__ + "img/zhga-2.4bc4f5f1.png";